import type { MaskOptions } from '@react-input/mask';

export const MASK_TOKENS = {
  '#': /\d/,
  $: /[a-zA-Z]/,
} as const;

export const DEFAULT_MASK_CONFIG = {
  replacement: MASK_TOKENS,
} as const satisfies MaskOptions;

export enum LiliMask {
  SSN = '###-##-####',
  DATE = '##/##/####',
  PHONE_US = '+1 (###) ###-####',
  EIN = '##-#######',
}

export type LiliCustomMask = LiliMask | string;
